import React from 'react';
import ReactDOM from 'react-dom';
//import './index.css';
//import App from './App';
//import registerServiceWorker from './registerServiceWorker';

import { Provider } from "react-redux";

import store from "./store";
import Router from "./router";

//import "todomvc-common/base.css";
//import "todomvc-app-css/index.css";

//import "./todomvc-julescubtree.css";
import "./todomvc-julescubtree.less";


ReactDOM.render(
  (
    <Provider store={store}>
      <Router />
    </Provider>
  ),
  document.getElementById('root')
);
//registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js